/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/rules-of-hooks */
import { IcoMoon, VehiclePlusSignIcon } from '@usap/uicomponents'
import { OverlaySpinner } from '@usap/widgets'
import React, { useCallback, useEffect, useState } from 'react'
import { toVehicleContext } from '../../../../../../DIFM/models/DifmVehicle'
import VehicleSelectorWmo from '../../../../../../vsComponent/VehicleSelectorWmo'
import useUpdateVehicle from '../hooks/useUpdateVehicle'

import {
  StyledFitmentCTA,
  StyledFitmentInfoContainer,
  StyledFitmentLabel,
  StyledIconContainer,
  StyledRequireVehicleWrapper,
} from '../VehicleFitmentWmo.css'

const GuaranteedFitWmo = ({
  product, showSpinner, shouldShowSpinner, recommendation = false, isCartItem = false,
}) => {
  const [cartVehicleDB, setCartVehicleDB] = useState()

  const fitmentLabel = 'Add Vehicle to Guarantee Fit!'
  const customIcon = VehiclePlusSignIcon
  const onAddVehicle = useCallback(
    vehicle => {
      const updatedVehicle = toVehicleContext(vehicle)
      updatedVehicle.itemId = product?.productId
      setCartVehicleDB(updatedVehicle)
    },
    [product],
  )

  const updateVehicle = useUpdateVehicle({
    cartVehicleDB,
    product,
    shouldShowSpinner,
  })

  let shouldRedirect = !recommendation
  if (isCartItem) shouldRedirect = false

  useEffect(() => {
    if (recommendation && cartVehicleDB?.year && window.localStorage) {
      const vehicleStorage = JSON.parse(window.localStorage.getItem('vehicleStorage'))
      const arrVehicleDB = vehicleStorage?.vehicleDB?.filter(vehicle => vehicle.selected !== true) || []

      const newSelectedVehicle = {
        selected: true,
        ...cartVehicleDB,
      }

      arrVehicleDB.push(newSelectedVehicle)

      const vehicleStorageObj = {
        selectedVehicle: cartVehicleDB,
        vehicleDB: arrVehicleDB,
      }
      window.localStorage.setItem('vehicleStorage', JSON.stringify(vehicleStorageObj))
      window.location.reload()
    } else if (cartVehicleDB?.year) {
      updateVehicle()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartVehicleDB])

  return (
    <StyledRequireVehicleWrapper data-testid="no-vehicle">
      {/* eslint-disable-next-line react-perf/jsx-no-new-object-as-prop */}
      <OverlaySpinner active={showSpinner} style={{ left: 0, top: 0 }} centered />

      <StyledIconContainer>
        <IcoMoon
          icon={customIcon}
        />
      </StyledIconContainer>
      <StyledFitmentInfoContainer>
        <StyledFitmentLabel>
          {fitmentLabel }
        </StyledFitmentLabel>
        <VehicleSelectorWmo
          componentType="dialog"
          button={(
            <StyledFitmentCTA
              label="Add Vehicle"
              dataTestId="add-vehicle-badge-cta"
              style={{
                fontFamily: 'Roboto',
                fontSize: '14px',
                color: '#282832',
              }}
            >
              Add Vehicle
            </StyledFitmentCTA>
          )}
          onAddVehicle={onAddVehicle}
          shouldRedirect={shouldRedirect}
        />
      </StyledFitmentInfoContainer>
    </StyledRequireVehicleWrapper>
  )
}

export default React.memo(GuaranteedFitWmo)
